export const enum ArmorClass {
  ArmorLess,
  Light,
  Medium,
  Heavy,
}

export const enum ArmorSlot {
  Head,
  Shoulder,
  Arm,
  Hand,
  Front,
  Back,
  Belly,
  Leg,
  Foot,
}
